import React from 'react';

export const PrivacyPolicy = () => {
  const currentDate = "29 juillet 2026";

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <p className="text-[10px] text-content-muted italic">Dernière mise à jour : {currentDate}</p>
      
      <section className="space-y-2">
        <h2 className="text-sm font-semibold text-[#c8a153]">1. Collecte et Utilisation des Données</h2>
        <p className="text-xs text-content-muted leading-relaxed">
          La plateforme SaaS <strong>L'IAmani</strong> collecte uniquement les données strictement nécessaires à son fonctionnement :
        </p>
        <ul className="list-disc pl-5 text-xs text-content-muted space-y-1">
          <li><strong>Données de connexion</strong> : Email, nom d'utilisateur, mots de passe chiffrés.</li>
          <li><strong>Données d'activité</strong> : Informations opérationnelles saisies par l'établissement (plannings, effectifs) nécessaires au service technique.</li>
          <li><strong>Données de sécurité</strong> : Adresses IP et journaux d'accès pour prévenir les abus.</li>
        </ul>
        <p className="text-xs text-content-muted leading-relaxed">
          Ces données ne sont jamais vendues ni cédées à des tiers.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-sm font-semibold text-[#c8a153]">2. Hébergement et Sécurité</h2>
        <p className="text-xs text-content-muted leading-relaxed">
          Toutes les informations sont hébergées de manière sécurisée sur l'infrastructure <strong>Cloudflare</strong>, en conformité avec les normes européennes de protection des données. L'accès aux données sensibles est protégé par un système de chiffrement (HTTPS en transit, AES-GCM au repos).
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-sm font-semibold text-[#c8a153]">3. Sous-traitants</h2>
        <p className="text-xs text-content-muted leading-relaxed">
          Pour assurer le fonctionnement du service, L'IAmani fait appel aux sous-traitants suivants, chacun n'ayant accès qu'aux données strictement nécessaires à sa mission :
        </p>
        <ul className="list-disc pl-5 text-xs text-content-muted space-y-1.5">
          <li><strong>Cloudflare, Inc.</strong> (États-Unis) — hébergement de l'application et de la base de données (Cloudflare Pages, D1). Héberge l'intégralité des données de la plateforme.</li>
          <li><strong>Resend</strong> — envoi des emails transactionnels (confirmations, notifications, identifiants temporaires). Reçoit les adresses email des destinataires et le contenu des emails envoyés.</li>
          <li><strong>Stripe</strong> — génération de liens de paiement en ligne pour les factures et acomptes. Chaque établissement utilisateur connecte son propre compte Stripe : L'IAmani ne perçoit et ne détient à aucun moment les fonds ni les données bancaires des clients finaux, qui transitent directement entre le client final et le compte Stripe de l'établissement.</li>
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-sm font-semibold text-[#c8a153]">4. Rôle de L'IAmani</h2>
        <p className="text-xs text-content-muted leading-relaxed">
          L'IAmani agit uniquement en qualité de <strong>Sous-traitant technique</strong> pour le compte des établissements utilisateurs, qui demeurent les Responsables de Traitement de leurs données.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-sm font-semibold text-[#c8a153]">5. Durée de conservation</h2>
        <p className="text-xs text-content-muted leading-relaxed">
          Les données sont conservées pendant la durée d'utilisation active du service par l'établissement. Les données d'un salarié supprimé par un établissement sont anonymisées après une période d'archivage, dans un objectif de limitation de la conservation. Un établissement peut à tout moment demander la suppression complète de son compte et de l'ensemble des données associées en contactant l'éditeur.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-sm font-semibold text-[#c8a153]">6. Droits (RGPD)</h2>
        <p className="text-xs text-content-muted leading-relaxed">
          Conformément à la réglementation (RGPD), vous disposez d'un droit d'accès, de rectification, de suppression, de portabilité et de limitation de vos données. Pour exercer ce droit, veuillez adresser votre demande à : <br/>
          <a href="mailto:contact@l-iamani.com" className="text-content hover:text-[#c8a153] transition-colors">contact@l-iamani.com</a>.
        </p>
        <p className="text-xs text-content-muted leading-relaxed">
          Vous disposez également du droit d'introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) — <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-content hover:text-[#c8a153] transition-colors">www.cnil.fr</a>.
        </p>
      </section>
    </div>
  );
};
